// extracted by mini-css-extract-plugin
export default {"main":"geschiedenis_main__fo+gS"};